import { useState, useEffect } from 'react';
import {
  type CurrencyCode,
  detectCurrency,
  formatPrice,
  getRegionalPrice,
  getFormattedPrices,
  REGIONAL_PRICES,
} from '../lib/currency';

interface UseCurrencyReturn {
  currency: CurrencyCode;
  formatPrice: (cents: number) => string;
  getRegionalPrice: (
    plan: keyof typeof REGIONAL_PRICES,
    interval: 'monthly' | 'yearly'
  ) => number;
  getFormattedPrices: (plan: keyof typeof REGIONAL_PRICES) => {
    monthly: string;
    yearly: string;
    yearlyPerMonth: string;
  };
}

/**
 * React hook for currency detection and formatting
 * Detects user's currency based on browser locale on mount
 */
export function useCurrency(): UseCurrencyReturn {
  const [currency, setCurrency] = useState<CurrencyCode>('USD');

  useEffect(() => {
    setCurrency(detectCurrency());
  }, []);

  return {
    currency,
    formatPrice: (cents: number) => formatPrice(cents, currency),
    getRegionalPrice: (plan, interval) => getRegionalPrice(plan, currency, interval),
    getFormattedPrices: (plan) => getFormattedPrices(plan, currency),
  };
}

export default useCurrency;
